import { createContext } from 'react';

const ErrorBoundaryContext = createContext({
  error: null,
  resetError: () => {},
  componentStack: null
});

export default ErrorBoundaryContext;
